import { GatewayService } from '../GatewayService';
import { PhicubeResponse } from '../interface/PhicubeResponse';

export class ConfiguracoesModel {

    impressaoDigital: Boolean = false
    reconhecimentoFacial: Boolean = false

    enviaOpcaoImpressaoDigital(impressaoDigital: Boolean): Promise<PhicubeResponse> {
        return new GatewayService().requestPut('/api/configuracoes/impressaoDigital', {impressaoDigital: impressaoDigital})
    }

    enviaOpcaoReconhecimentoFacial(reconhecimentoFacial: Boolean): Promise<PhicubeResponse> {
        return new GatewayService().requestPut('/api/configuracoes/reconhecimentoFacial', {reconhecimentoFacial: reconhecimentoFacial})
    }

    removeConta(): Promise<PhicubeResponse> {
        return new GatewayService().requestDel('/api/user/me')
    }
}